import { render, staticRenderFns } from "./employerMergerForm.vue?vue&type=template&id=87396fd6&scoped=true"
import script from "./employerMergerForm.vue?vue&type=script&lang=js"
export * from "./employerMergerForm.vue?vue&type=script&lang=js"
import style0 from "./employerMergerForm.vue?vue&type=style&index=0&id=87396fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87396fd6",
  null
  
)

export default component.exports